export const cacheKeys = {
  detail: (workspaceId: number, brandVisualKitId: number, id: number | undefined) =>
    ['workspaces', workspaceId, 'brandVisualKits', brandVisualKitId, 'brandVisualEnhancements', 'detail', id] as const,
} as const
